import { render, staticRenderFns } from "./VBuyOrSell.vue?vue&type=template&id=8e401ff4&scoped=true"
import script from "./VBuyOrSell.vue?vue&type=script&lang=js"
export * from "./VBuyOrSell.vue?vue&type=script&lang=js"
import style0 from "./VBuyOrSell.vue?vue&type=style&index=0&id=8e401ff4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e401ff4",
  null
  
)

export default component.exports